import classnames from 'classnames';
import { func, string } from 'prop-types';
import React from 'react';
import { ExpandableInput } from '@eika/expandable-input';
import ErrorMessage from '../../errormessage';

const Textarea = ({ id, name, onChange, onBlur, label, value, className, errorText, maxLength }) => {
    return (
        <div className={classnames(className, { 'has-error error': errorText })}>
            <label htmlFor={`${name}_${id}`} className="control-label">
                {label}
            </label>
            <ExpandableInput
                name={name}
                onChange={onChange}
                className="form-control"
                value={value}
                id={`${name}_${id}`}
                onBlur={onBlur}
                maxLength={maxLength}
            />
            {errorText ? <ErrorMessage text={errorText} /> : null}
        </div>
    );
};

Textarea.propTypes = {
    id: string.isRequired,
    name: string.isRequired,
    onChange: func.isRequired,
    onBlur: func,
    label: string.isRequired,
    value: string,
    className: string,
    maxLength: string,
};

export default React.memo(Textarea);
